import {
  PracticeDeliveryMode,
  PracticeHistoryKind,
  PracticeStatus,
} from '../types/practice'

export const practiceStatuses: PracticeStatus[] = [
  'Positivo',
  'In valutazione',
  'Negativo',
]

export const practiceHistoryKinds: { kind: PracticeHistoryKind; label: string }[] =
  [
    { kind: 'telefono', label: 'Contatto telefonico' },
    { kind: 'email', label: 'Contatto email' },
    { kind: 'messaggio', label: 'Contatto messaggio' },
    { kind: 'sollecito', label: 'Sollecito' },
    { kind: 'incontro', label: 'Incontro diretto' },
  ]

export const practiceDeliveryModes: {
  value: PracticeDeliveryMode
  label: string
}[] = [
  { value: 'aziendale', label: 'Corso commessa aziendale in presenza' },
  { value: 'multiaziendale', label: 'Corso commessa multi-aziendale in presenza' },
  { value: 'elearning', label: 'Corso On-demand' },
]

// Elenco "Esterni e Partner" (valori di esempio)
export const externalPartners = [
  'Studio Commercialisti Rossi & Associati',
  'Confartigianato Arezzo',
  'CNA Toscana',
  'Partner Sicurezza Srl',
  'Consulente del lavoro Dott. Verdi',
]
